<div class="row">
  <div class="col-md-12">
    <div id="mapid" style="height: 70vh; margin-bottom: 10px"> </div>
  </div>
</div>

<div class="row">
  <div class="col-md-4 col-xs-12">
    <div class="card shadow-sm" *appHideIfNotInRole="['vessels-viewer']">
      <div class="card-header">Last voyages</div>
      <div class="card-body">
        <div class="table table-sm-responsive">
        <div class="col-md-12 col-xs-12">
        <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        [columnDefs]="columnDefs" 
        [rowData]="ongoingVoyages" 
        [domLayout]="'autoHeight'"
        [pagination]= "true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
      </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8 col-xs-12">
    <div class="card shadow-sm ">
      <div class="card-header">Arrivals & Departures</div>
      <div class="card-body">
        <div class="table table-sm-responsive">
        <div class="col-md-12 col-xs-12">
        <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        [columnDefs]="arrivalsColumnDefs" 
        [rowData]="arrivalDepartures" 
        [domLayout]="'autoHeight'"
        [pagination]= "true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
      </div>
        </div>
      </div>
    </div>
  </div>
</div>
